import graphql__5cf805401c9e257dd37c from "./__generated__/AnswerPreviewPresentationTextZone_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewPresentationTextZone = function() {
  return null;
};

export default createFragmentContainer(AnswerPreviewPresentationTextZone, {
  answer: graphql__5cf805401c9e257dd37c
});
